"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Listeners {
  constructor() {
    _defineProperty(this, "listenerSets", {
      scope: new Set([]),
      user: new Set([])
    });
  }

  add(key, callback) {
    this.listenerSets[key].add(callback);
  }

  delete(key, callback) {
    this.listenerSets[key].delete(callback);
  }

  call(key, value) {
    this.listenerSets[key].forEach(listener => {
      listener(value);
    });
  }

}

var _default = new Listeners();

exports.default = _default;